import { CDN_URL, formatMoney } from "../Helpers"
import PurchasePanel from "./PurchasePanel"

export default function ContentDetails({ data, type }) {
  return (
    <>
      <section className="marketplace-detail-cover">
        <img src={CDN_URL + data.coverPhoto} alt={data.title} />
        <div className="marketplace-detail-overlay"></div>
        <div className="container marketplace-detail-heading">
          <span className="marketplace-eyebrow">{type}</span>
          <h1>{data.title}</h1>
        </div>
      </section>

      <div className="container marketplace-detail-container">
        <div className="row g-4">
          <div className="col-12 col-lg-8">
            <div className="card marketplace-detail-card">
              <div className="card-body">
                <h6 className="section-title">About this {type.toLowerCase()}</h6>
                <div
                  className="marketplace-rich-content"
                  dangerouslySetInnerHTML={{ __html: data.description }}
                >
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 col-lg-4">
            <div className="card marketplace-purchase-card">
              <div className="card-body">
                <span className="marketplace-type-badge marketplace-static-badge">{type}</span>
                <h6 className="marketplace-detail-price">TZS {formatMoney(data.price)}</h6>
                <PurchasePanel data={data} type={type} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
